import type { VoidFunctionComponent } from 'react';

import { SNIPPET_DETECTION } from '../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../helpers/features';
import Subnav from '../../generic/Subnav';
import SubnavCountBadge from '../../generic/Subnav/SubnavCountBadge';

type Props = {
  baseRevisionURL: string;
  revisionId: string | null;
  isLoading: boolean;
  dependencyCount: number;
};

/**
 * ProjectSubNavInventory contains the subnav item for the "Inventory" section.
 * For orgs where Snippet Scanning is not enabled, this is basically just the old Dependencies subnav item.
 * For orgs where Snippet Scanning is enabled, this is the Inventory dropdown.
 */
const ProjectSubNavInventory: VoidFunctionComponent<Props> = ({
  baseRevisionURL,
  revisionId,
  isLoading,
  dependencyCount,
}) => {
  const isSnippetScanningEnabled = useIsFeatureEnabled(SNIPPET_DETECTION);

  if (!isSnippetScanningEnabled) {
    return (
      <Subnav.ItemWithCount
        to={`${baseRevisionURL}/browse/dependencies`}
        navKey="browse/dependencies"
        count={dependencyCount}
        isLoading={!revisionId || isLoading}
      >
        Dependencies
      </Subnav.ItemWithCount>
    );
  }

  return (
    <Subnav.Dropdown
      to={`${baseRevisionURL}/browse/dependencies`}
      navKey="inventory"
    >
      <Subnav.Dropdown.RootItem>
        Inventory
        <SubnavCountBadge count={dependencyCount || 0} isLoading={dependencyCount === null} />
      </Subnav.Dropdown.RootItem>
      <Subnav.Dropdown.Item to={`${baseRevisionURL}/browse/dependencies`} navKey="browse/dependencies">
        Dependencies
        <SubnavCountBadge count={dependencyCount || 0} isLoading={dependencyCount === null} />
      </Subnav.Dropdown.Item>
      <Subnav.Dropdown.Item to={`${baseRevisionURL}/browse/snippets`} navKey="snippets">
        Snippets
      </Subnav.Dropdown.Item>
    </Subnav.Dropdown>
  );
};

export default ProjectSubNavInventory;
